import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b3f12328&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=b3f12328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f12328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3f12328')) {
      api.createRecord('b3f12328', component.options)
    } else {
      api.reload('b3f12328', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=b3f12328&scoped=true&", function () {
      api.rerender('b3f12328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/freelanceTask/detail.vue"
export default component.exports